// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"a0697591","251":"0715edef"}[chunkId] + ".chunk.js";
};